import { restApiKey } from '../../../../_constants/Code'
import { httpGet, httpPost } from '../../../../services/api/AmplifyApi'
import { PathInfoList } from '../../../../_constants/PathInfoList'

/**
 * 判定ルール一覧を取得する（get_judgment_rule API）
 *
 * @param {string} corporationNumber
 * @returns {Promise<import('./types').JudgmentRuleRow[]>} 判定ルール一覧（CreateDateTime降順でソート済み）
 */
export async function fetchJudgmentRuleList(corporationNumber) {
  try {
    const init = {
      headers: {}
    }
    const response = await httpGet(
      restApiKey.CHROFY_REST_API,
      PathInfoList.Resource.getJudgmentRule(corporationNumber),
      init
    )

    // レスポンスのbodyを取得（response.bodyが存在する場合はそれを使用、そうでない場合はresponse自体を使用）
    const rows = response.body || (Array.isArray(response) ? response : [])

    if (!Array.isArray(rows)) return []

    // CreateDateTime降順でソート
    return rows.sort((a, b) => {
      const dateA = a.CreateDateTime ? new Date(a.CreateDateTime) : new Date(0)
      const dateB = b.CreateDateTime ? new Date(b.CreateDateTime) : new Date(0)
      return dateB - dateA
    })
  } catch (err) {
    // 404エラーの場合は空配列を返す
    if (err.response?.status === 404 || err.response?.statusCode === 404) {
      return []
    }
    console.error('判定ルール一覧の取得に失敗しました:', err)
    throw err
  }
}

/**
 * 判定ルールを削除する（delete_judgment_rule API）
 *
 * @param {string} corporationNumber
 * @param {string} ruleId 削除対象のルールID
 * @param {string} userSub ユーザーID（未使用、将来の履歴登録用）
 * @returns {Promise<Object>} 削除結果
 */
export async function deleteJudgmentRule(corporationNumber, ruleId, userSub) {
  try {
    const init = {
      body: {
        rule_id: ruleId
      },
      headers: {}
    }
    return await httpPost(restApiKey.CHROFY_REST_API, PathInfoList.Resource.deleteJudgmentRule(corporationNumber), init)
  } catch (err) {
    console.error('判定ルールの削除に失敗しました:', err)
    throw err
  }
}
